import {
  EnvironmentProviders,
  InjectionToken,
  makeEnvironmentProviders,
} from '@angular/core';

export interface KeycloakConfig {
  issuer: string;
  clientId: string;
  redirectUri: string;
  scopes: string;
  /**
   * Web only. On bootstrap without a stored session, spend one `prompt=none`
   * round trip asking Keycloak whether its SSO cookie can supply one. Worth it
   * for apps served from several origins that share one Keycloak — BeeKing's
   * per-tenant hosts each keep their own localStorage, so without this every
   * tenant asks for credentials again.
   *
   * Off by default: it costs a redirect on every anonymous page load, and a
   * build with no real issuer (the BeeKing demo) must never navigate away.
   */
  silentSso?: boolean;
}

export const KEYCLOAK_CONFIG = new InjectionToken<KeycloakConfig>(
  'KEYCLOAK_CONFIG'
);

export function provideKeycloakAuth(
  config: KeycloakConfig
): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: KEYCLOAK_CONFIG, useValue: config },
  ]);
}
